import React from 'react'
import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

import { useQuery } from '~/client/hooks/cqrpc'
import { useCurrentUser } from '~/client/hooks/auth'
import Link from '~/client/components/Link'
import Heading from '~/client/components/Heading'
import AppIcon from '~/client/components/AppIcon'
import ButtonRow from '~/client/components/ButtonRow'

export default function Page() {
  let { host } = useParams()
  const { currentUser } = useCurrentUser()
  const query = useQuery('apps.getByHost', { host })
  const app = query.result
  return <Container maxWidth="md">
    {app
      ? <Paper sx={{m: 2, p: 2}}>
        <Stack direction={{sx: 'column', md: "row"}} spacing={2} alignItems="center">
          <Stack direction="row" spacing={2} alignItems="center">
            <AppIcon app={app}/>
            <Heading>{app.name}</Heading>
          </Stack>
          {app.ownerId === currentUser.id
            ? <ButtonRow sx={{flexGrow: 1}}>
              <Button
                variant="outlined"
                component={Link}
                to={`/settings/apps/${app.host}`}
              >MANAGE</Button>
            </ButtonRow>
            : null
          }
        </Stack>
        <p sx={{whiteSpace: 'pre-wrap'}}>{app.description}</p>
        <Heading variant="sub">Homepage</Heading>
        <Link to={app.homepageUrl}>{app.homepageUrl}</Link>
      </Paper>
      : null
    }
  </Container>
}
